<template>
    <div :class="{ 'modal-width-categories': type == 'is-category', 'modal-width-plan-account': type == 'is-account' }"
        class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered classify_title">
                <strong>
                    {{ tittleModal }}
                </strong>
            </h3>
            <div class="total_indicator"> <strong> Total: </strong> <span
                    :class="total == 100 ? 'right_total' : 'wrong_total'">{{
                        total
                    }}%</span></div>
            <p v-if="documentsIds" class="docs_selected">
                <strong v-if="documentsIds.length > 1"> {{ documentsIds.length }} documentos seleccionados</strong>
            </p>
            <button class=" delete" aria-label="Cerrar Modal" @click="$emit('close')" />
            <br>
        </header>
        <section class="modal-card-body pt-0">
            <div class="px-2">
                <div class="has-text-centered is-size-4">{{ categoryType }} </div>
                <div class="table_container">
                    <table class="table is-hoverable is-fullwidth">
                        <thead v-if="type == 'is-account'">
                            <th class="p_header"></th>
                            <th class="p_header" style="min-width:120px; width:150px">Prorrata %</th>
                            <th class="p_header">Clasificación cuenta</th>
                            <th class="p_header">Nivel 2</th>
                            <th class="p_header">Nivel 1</th>
                        </thead>
                        <thead v-if="type == 'is-category'">
                            <th class="p_header"></th>
                            <th class="p_header" style="min-width:120px; width:150px">Prorrata %</th>
                            <th class="p_header">Nombre</th>
                        </thead>
                        <tbody v-if="type == 'is-account'">
                            <tr v-for="(renderItem, index) in listRender" v-bind:key="renderItem.id">
                                <td class="fila_class big_check">
                                    <button @click="selectRow(renderItem, index)" :class="[
                                        'first_button',
                                        { unselected_button: !renderItem.selected },
                                        { selected_button: renderItem.selected }]">
                                        {{ renderItem.selected ? " ✔" : "" }} </button>
                                </td>
                                <td class="prorate_validator fila_class">
                                    <InputWithValidation type="number" placeholder="0" hardcore="true"
                                        rules="integer|max_value:100|min_value:0"
                                        v-model="prorateEdit[renderItem.id]" />
                                </td>
                                <td class="fila_class" @click="selectRow(renderItem, index)"> {{ renderItem.level_3 }}
                                </td>
                                <td class="fila_class" @click="selectRow(renderItem, index)"> {{ renderItem.level_2 }}
                                </td>
                                <td class="fila_class" @click="selectRow(renderItem, index)"> {{ renderItem.level_1 }}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="type == 'is-category'">
                            <tr v-for="(renderItem, index) in listRender" v-bind:key="renderItem.id">
                                <td class="fila_class big_check">
                                    <button @click="selectRow(renderItem, index)" :class="[
                                        'first_button',
                                        { unselected_button: !renderItem.selected },
                                        { selected_button: renderItem.selected }]">
                                        {{ renderItem.selected ? " ✔" : "" }} </button>
                                </td>
                                <td class="prorate_validator fila_class">
                                    <InputWithValidation type="number" placeholder="0" hardcore="true"
                                        rules="integer|max_value:100|min_value:0" inputClasses="is-small"
                                        v-model="prorateEdit[renderItem.id]" />
                                </td>
                                <td class="fila_class" @click="selectRow(renderItem, index)"> {{ renderItem.name }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> <!-- container_table -->

            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <div class="total_indicator_footer"> <strong> Total: </strong> <span
                    :class="total == 100 ? 'right_total' : 'wrong_total'">{{
                        total
                    }}%</span></div>
            <b-button class="button" @click="() => deleteProrateEntry()" type=" is-secondary">
                Reiniciar
            </b-button>

            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>

            <b-button @click="() => saveProrateByContraparte()" :disabled="!isValidInputs || total != 100 || processing"
                class="p-3" type="is-primary">
                Grabar
            </b-button>
        </footer>
    </div>
</template>


<script>

import {
    delete_prorate_by_company_involved,
    get_prorates_x_company_involved,
    save_prorate_by_company_involved
} from "@/api/carteraAnalista";
import InputWithValidation from "@/components/inputs/InputWithValidation";
import { consoleHandlerError, notificate } from "@/utils/message";
export default {
    name: "ClassifyAccountAttributes",
    components: {
        InputWithValidation,
    },
    data() {
        return {
            loading: null,
            prorateEdit: {},
            listRender: [],
            total: 0,
            processing: false,
        };
    },
    methods: {
        selectRow(row, index) {
            this.listRender[index]['selected'] = !row['selected'];
            this.listRender = [...this.listRender];
            this.prorrateEqually();
        },
        prorrateEqually() {
            let howMany = 0;
            for (const elem of this.listRender) {
                if (elem['selected']) {
                    howMany++;
                } else {
                    this.prorateEdit[elem.id] = '';
                }
            }
            if (howMany > 0) {
                let partial = Math.floor(100 / howMany);
                let currTotal = 0;
                for (const elem of this.listRender) {
                    if (elem['selected']) {
                        this.prorateEdit[elem.id] = partial;
                        howMany--;
                        if (howMany == 0) {
                            this.prorateEdit[elem.id] = 100 - currTotal;
                            break;
                        }
                        currTotal += partial
                    }
                }
            }
            this.prorateEdit = { ...this.prorateEdit };
        },
        saveProrateByContraparte() {
            this.processing = true;
            let body = {
                period_months: this.current_period,
                idCompanyInvolved: this.contraparteId,
                prorates: [],
                typeProrate: this.type,
                documentsIds: this.documentsIds,
                documentType: this.document_type,
            }
            for (const [key, value] of Object.entries(this.prorateEdit)) {
                if (value && value != 0) {
                    body.prorates.push({
                        idObjectProrate: key,
                        percentage: value
                    })
                }
            }
            if (body.prorates.length == 0) {
                return
            }
            this.getFuncSaveProrate(body).then((response) => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    Se guardo la prorrata con éxito`,
                    "is-success is-light"
                );
                this.$emit('close', response.data['reloaded_rows'])
                this.processing = false;
            }).catch(error => {
                consoleHandlerError({ error, empty: false });
                this.processing = false;
            })
        },
        getFuncSaveProrate(body) {
            return save_prorate_by_company_involved(body)
        },
        deleteProrateEntry() {
            let body = {
                period_months: this.current_period,
                idCompanyInvolved: this.contraparteId,
                typeProrate: this.type,
                documentsIds: this.documentsIds,
                categoryType: this.categoryType,
                documentType: this.document_type,
            }
            delete_prorate_by_company_involved(body).then((response) => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    Se reinicio la prorrata`,
                    "is-warning is-light"
                );
                this.$emit('close', response.data['reloaded_rows'])
            }).catch(error => {
                consoleHandlerError({ error, empty: false });
            })
        }

    },
    computed: {
        isValidInputs() {
            let isAllEmpty = true
            for (const key of Object.keys(this.prorateEdit)) {
                if (isNaN(this.prorateEdit[key])) {
                    return false
                }
                if (this.prorateEdit[key]) {
                    isAllEmpty &&= false
                }
            }
            return !isAllEmpty
        },
    },
    mounted() {
        let remote_call = this.prefetched;
        if (!this.prefetched) {
            remote_call = get_prorates_x_company_involved(this.contraparteId, this.documentIdSelected, this.document_type);
        }
        remote_call.then((prorateResponse) => {
            if (this.type == 'is-account') {
                const account_plan_ordered = prorateResponse.data['account_plan_ordered'];
                const prorate_x_account = prorateResponse.data['prorate_x_account'];
                this.listRender = [...account_plan_ordered];
                prorate_x_account.map(prorateXAccount => {
                    this.prorateEdit[prorateXAccount.classified_account] = prorateXAccount.percentage;
                });
                this.prorateEdit = { ...this.prorateEdit };
                for (const elem of this.listRender) {
                    elem['selected'] = false;
                    if (this.prorateEdit[elem['id']] != '' && this.prorateEdit[elem['id']] > 0) {
                        elem['selected'] = true;
                    }
                }
            } else {
                const prorates_x_attribute = prorateResponse.data['prorates_x_attribute'];
                const specific_prorates_x_attribute = prorates_x_attribute.filter(attr => attr.attribute_type == this.categoryType);

                const all_attributes = prorateResponse.data['all_attributes'];
                const specific_attributes = all_attributes.filter(attr => attr.type == this.categoryType);

                this.listRender = [...specific_attributes];
                specific_prorates_x_attribute.forEach(prorateXAttribute => {
                    this.prorateEdit[prorateXAttribute.classified_attribute] = prorateXAttribute.percentage;
                });
                this.prorateEdit = { ...this.prorateEdit };
                for (const elem of this.listRender) {
                    elem['selected'] = false;
                    if (this.prorateEdit[elem['id']] != '' && this.prorateEdit[elem['id']] > 0) {
                        elem['selected'] = true;
                    }
                }
            }
        }).catch(error => {
            console.error('Error in one of the API calls:', error);
        });
    },
    watch: {
        prorateEdit: {
            handler: function (prorateInputs) {
                this.total = 0
                for (const key of Object.keys(prorateInputs)) {
                    if (!isNaN(prorateInputs[key]) && '' != prorateInputs[key]) {
                        this.total += parseInt(prorateInputs[key])
                    }
                }
                this.$forceUpdate();
            },
            deep: true
        }
    },
    props: {
        tittleModal: String,
        contraparteId: Number,
        type: String,
        categoryType: String,
        documentsIds: Array,
        documentIdSelected: Number,
        document_type: String,
        current_period: Number,
        prefetched: Promise,
    }
};
</script>

<style scoped>
.modal-width-categories {
    width: 100%;
    min-width: 500px;
    max-width: 800px;
}

.modal-width-plan-account {
    width: 100%;
    max-width: 950px;
}

.first_button {
    width: 40px;
    height: 40px;
    margin: 3px;
    transition: background-color 0.15s ease, border 0.15s ease;
}

.unselected_button {
    background-color: #f1f1f1;
    border: 2px inset #dddddd;
}

.selected_button {
    border-radius: 4px;
    color: #ffffff;
    font-weight: bold;
    background-color: #3333ff;
    border: 4px outset #dddddd;
}

.right_total {
    color: black;
    font-weight: 600;
    font-style: normal;
}

.wrong_total {
    color: red;
    font-style: italic;
}

.docs_selected {
    position: absolute;
    left: 38%;
    top: 55px;
}

.total_indicator {
    position: absolute;
    left: 66px;
    top: 55px;
}

.total_indicator_footer {
    position: absolute;
    left: 66px;
    top: 10px;
}

.p_header {
    position: sticky;
    top: 0;
    background: #f9f9f9;
    z-index: 200;
}

.classify_title {
    height: 2em;
}

.big_check {
    text-align: center;
}

.fila_class {
    height: 30px;
    vertical-align: middle;
}

.prorate_validator {
    padding: 0 15px 0 15px !important;
    margin-bottom: 8px;
}

.table td {
    padding: 0;
}
</style>
